module.exports = __webpack_public_path__ + "media/c2.652610c8.mp4";